module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Ho-Hak")])])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The rence islands, on which the communities of rence growers dwell, are rather small, seldom more than two hundred by two hundred and fifty feet. They are formed entirely from the interwoven stems of the rence plants and float in the marsh. They are generally about eight to nine feet thick and have an exposed surface above the water of about three feet; as the rence stems break and rot away beneath the island, more layers are woven and placed on the surface. Thus, over a period of months, a given layer of rence, after being the top layer, will gradually be submerged and forced lower and lower until it, at last, is the deepest layer and, with its adjacent layers, begins to deteriorate.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("To prevent an unwanted movement of the island there are generally several tethers, of marsh vine, to strong rence roots in the vicinity. It is dangerous to enter the water to make a tether fast because of the predators that frequent the swamp, but several men do so at a time, one man making fast the tether and the others, with him beneath the surface, protecting him with marsh spears, or pounding on metal pieces or wooden rods to drive away, or at least to disconcert and confuse, too inquisitive, undesired visitors, such as the water tharlarion or the long-bodied, nine-gilled marsh shark.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When one wishes to move the island, the tethers are simply chopped away, and the community divides itself into those who will handle the long poles and those who will move ahead in rence craft, cutting and clearing the way. Most of those who handle the poles gather on the edges of the island, but within the island there are four deep rectangular wells through which the long poles may gain additional leverage. These deep center wells, actually holes cut in the island, permit its movement, though slowly when used alone, without exposing any of its inhabitants at its edges, where they might fall easier prey to the missile weapons of foes. In times of emergency the inhabitants of the island gather behind wickerlike breastworks, woven of rence, in the area of the center wells; in such an emergency the low-ceilinged rence huts on the island will have been knocked down to prevent an enemy from using them for cover, and all food and water supplies, usually brought from the eastern delta where the water is fresh, will be stored within; the circular wickerlike breastworks then form, in the center of the island, a more or less defensible stronghold, particularly against the marsh spears of other growers, and such. Ironically, it is not of much use against an organized attack of well-armed warriors, such as those of Port Kar, and those against whom it might be fairly adequate, other rence growers, seldom attack communities like their own. I had heard there had not been general hostilities among rence growers for more than fifty years; their communities are normally isolated from one another, and they have enough to worry about contending with \"tax collectors\" from Port Kar, without bothering to give much attention to making life miserable for one another. Incidentally, when the island is to be moved under siege conditions, divers leave the island by means of the wells and, in groups of two and three, attempt to cut a path in the direction of escape; such divers, of course, often fall prey to underwater predators and to the spears of enemies, who thrust down at them from the surface. Sometimes an entire island is abandoned, the community setting it afire and taking to the marsh in their marsh skiffs. At a given point, when it is felt safe, several of these skiffs will be tied together, forming a platform on which rence may be woven, and a new island will be begun.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"So,\" said Ho-Hak, regarding me, \"you are on your way to Port Kar?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He sat upon a giant shell of the Vosk sorp, as on a sort of throne, which, for these people, I gather it was.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I knelt before him, naked and bound. Two ropes of marsh vine, besides my other bonds, had been knotted about my neck, each in the hands of a man on either side of me. My ankles had been unbound only long enough to push me stumbling from the rush craft, among the shouting women and men and children, to the throne of Ho-Hak. Then I had been forced to my knees, and my ankles had again been lashed together.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" I said. \"It was my intention to go to Port Kar.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We are not fond of the men of Port Kar,\" Ho-Hak said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was a rusted, heavy iron collar riveted about the neck of Ho-Hak, with a bit of chain dangling from it. I gathered that the rence growers did not have the tools to remove it. Ho-Hak might have worn it for years. He was doubtless a slave, probably escaped from the galleys of Port Kar, who had fled to the marshes and been befriended by rence growers. Now, years later, he had come to a position of authority among them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am not of Port Kar,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What is your city?\" asked he.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I did not speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Why do you go to Port Kar?\" asked Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Again I did not speak. My identity, that I was Tarl Cabot, and my mission, that I served the Priest-Kings of Gor, was not for others to know. Coming from the Sardar, I knew only that I was to travel to Port Kar and there make contact with Samos, first slaver of Port Kar, scourge of Thassa, said to be trusted of Priest-Kings.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You are an outlaw,\" said Ho-Hak, as had the girl before him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I shrugged.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was true that my shield, and my clothes, now taken from me, bore no insignia.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak looked at the garb of the warrior, the helmet and shield, the sword with its scabbard, and the leather-wrapped bow of supple Ka-la-na wood, with its roll of sheaf and flight arrows. These things lay between us.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak's right ear twitched. His ears were unusual, very large, and with extremely long lower lobes, drawn lower still by small, heavy pendants set in them. He had been a slave, doubtless, and, doubtless, judging by the collar, and the large hands and broad back, had served on the galleys, but he had been an unusual slave, a bred exotic, doubtless originally intended by the slave maters for a destiny higher than that of the galley bench.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There are various types of \"exotics\" bred by Gorean slavers, all of whom are to be distinguished from more normal varieties of bred slaves, such as Passion Slaves and Draft Slaves. Exotics may be bred for almost any purpose, and some of these purposes, unfortunately, seem to be little more than to produce quaint or unusual specimens. Ho-Hak may well have been one so bred.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You are an exotic,\" I said to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak's ears leaned forward toward me, but he did not seem angry. He had brown hair, and brown eyes; the hair, long, was tied behind his head with a string of rence cloth. He wore a sleeveless tunic of rence cloth, like most of the rence growers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Ho-Hak. \"I was bred for a collector.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I see,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I broke his neck and escaped,\" said Ho-Hak. \"Later I was recaptured and sent to the galleys.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"And you again escaped,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"In doing so,\" said Ho-Hak, looking at his large hands, heavy and powerful, \"I killed six men.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"And then you came to the marshes,\" said I.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" he said, \"I then came to the marshes.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He regarded me, the ears leaning slightly toward me. \"And I brought to the marshes with me,\" said he, \"the memory of a dozen years on the galleys, and a hatred for all things of Port Kar.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There were various rence growers gathered about, the men with their marsh spears. Almost at my side stood the blondish girl I had seen, she who had been primarily effectual in my capture, herself acting as the bait, the lure to which I had been drawn. She stood proudly beside me, straight, her shoulders back, her chin high, as does a free woman beside a miserable slave, naked and kneeling. I was conscious of her thigh at my cheek. Over her shoulder were slung the four birds she had caught in the marshes; their necks were now broken and they were tied together, two in front and two over her back. There were other women about as well, and, here and there, peering between the adults, I could see children.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He is either of Port Kar,\" she said, shifting the gants on her shoulder, \"or he was intending to be of Port Kar. For what other reason would one go to Port Kar?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("For a long time Ho-Hak said nothing. He had a broad head, with a heavy, calm face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I heard the squealing of a domestic tarsk running nearby, its feet scuttling in the woven rence of the island, as on a mat. A child was crying out, chasing it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I heard some domestic marsh gants making their piping call. They wandered freely on the island, leaving it to feed, then returning to it later. Wild marsh gants, captured, even as young as gantlings, cannot be domesticated; on the other hand, eggs, at the hatching point, gathered from floating gant nests, are sometimes brought to the island; the hatchlings, interestingly, if not permitted to see an adult gant for the first week of their life, then adopt the rence island as their home, and show no fear of human beings; they will come and go in the wild as they please, feeding and flying, but will always, and frequently, return to the rence island, their hatching place; if the rence island, however, should be destroyed, they revert entirely to the wild; in the domesticated state, it might be mentioned, they will often come to whistles, and will invariably permit themselves to be picked up and handled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There were several reasonably important looking individuals gathered about, and, as it turned out, these were headmen from various other rence islands in the vicinity. A given rence island usually holds about fifty or sixty persons. The men from several of these islands had cooperated in my pursuit and capture. Normally, as I may have mentioned, these communities are isolated from one another, but it was now near the Autumnal Equinox, and the month of Se'Kara was shortly to begin. For rence growers, the first of Se'Kara, the date of the Autumnal Equinox, is a time of festival. By that time most of the year's rence will have been cut, and great stocks of rence paper, gathered in rolls like cord wood and covered with woven rence mats, will have been prepared.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Between Se'Kara and the winter solstice, which occurs on the first of Se'Var, the rence will be sold or bartered, sometimes by taking it to the edge of the delta, sometimes by being contacted by rence merchants, who enter the delta in narrow barges, rowed by slaves, in order to have first pick of the product.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The first of Se'Var is also a date of festival, it might be mentioned, but this time the festival is limited to individual, isolated rence islands. With the year's rence sold, the communities do not care to lie too closely to one another; the primary reason is that, in doing so, they would present too inviting a target for the \"tax collectors\" of Port Kar. Indeed, I surmised, there was risk enough, and great risk, coming together even in Se'Kara. The unsold stores of rence paper on the islands at this time would, in themselves, be a treasure, though, to be sure, a bulky one.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But I felt there was something strange going on, for there must have been five or six headmen on the island with Ho-Hak at this time. It is seldom, even in Se'Kara, that so many rence islands would gather for festival. Usually it would be two or three. At such times there is drinking of rence beer, steeped, boiled and fermented from crushed seeds and the whitish pith of the plant; singing; games; contests and courtship, for the young people of the rence islands too seldom meet those of the other communities. Why should there be so many rence islands in the same vicinity, even though it was near the first of Se'Kara? Surely the capture of one traveler in the delta did not warrant this attention, and, of course, the islands must have been gathered together even before I had entered the area.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He is a spy,\" said one of the other men present, who stood beside Ho-Hak. This man was tall, and strong looking. He carried a marsh spear. On his forehead there was tied a headband formed of the pearls of the Vosk sorp.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I wondered what in particular there might be to spy about on the rence islands.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak still did not speak, but sat on the shell of the Vosk sorp, looking down at the weapons, mine, before him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I squirmed a bit in the marsh vine that constrained me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do not move, Slave,\" snapped the girl, who stood beside me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Immediately the two loops of marsh vine knotted about my neck tightened, each taut, pulling against the other.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The girl's hands were in my hair and she yanked my head back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He is of Port Kar,\" she said, her hands in my hair, \"or intended to be of Port Kar!\" She glared at Ho-Hak, as though demanding that he speak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But Ho-Hak did not speak, nor did he seem particularly to notice the girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Angrily she removed her hands from my hair, thrusting my head to one side.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak seemed intent on regarding the leather-wrapped bow of supple Ka-la-na wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The women of rence growers, when in their own marshes, do not veil themselves, as is common among Gorean women, particularly of the cities. Moreover, they are quite capable of cutting rence, preparing it, hunting for their own food and, on the whole, of existing, if they wish it, by themselves. There are few tasks of the rence communities which they cannot perform as well as men. Their intelligence, and the work of their hands, is needed by the small communities. Accordingly they suffer little inhibition in the matters of speaking out and expressing themselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak reached down and unwrapped the leather from the yellow bow of supple Ka-la-na. The roll of sheaf and flight arrows spilled out to the woven mat that was the surface of the rence island.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There were gasps from two or three of the men present. I gathered they had seen small straight bows, but that this was the first long bow they had seen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak stood up. The bow was taller than several of the men present.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He handed the bow to the blondish girl, she with blue eyes, who had been instrumental in my capture.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"String it,\" said he to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Angrily she threw the marsh gants from her shoulder and took the bow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She seized the bow in her left hand and braced the bottom of it against the instep of her left foot, taking the hemp cord whipped with silk, the string, in her right hand. She struggled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At last, angrily, she thrust the bow back into the hands of Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak looked down at me, the large ears inclining toward me slightly. \"This is the peasant bow, is it not?\" he asked. \"Called the great bow, the long bow?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Long ago,\" said he, \"in a village once, on the lower slopes of the Thentis range, about a campfire, I heard sing of this bow.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I said nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He handed the bow to the fellow with the headband of pearls of the Vosk sorp bound about his forehead. \"String it,\" said Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The fellow handed his marsh spear to a companion and turned to the bow. He took it confidently. Then the look of confidence vanished. Then his face reddened, and then the veins stood out on his forehead, and then he cried out in disgust, and then he threw the bow back to Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak looked at it and then set it against the instep of his left foot, taking the bow in his left hand and the string in his right.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was a cry of awe from about the circle as he strung the bow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I admired him. He had strength, and much strength, for he had strung the bow smoothly, strength it might be from the galleys, but strength, and superb strength.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Well done,\" said I to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then Ho-Hak took, from among the arrows on the mat, the leather bracer and fastened it about his left forearm, that the arm not be lacerated by the string, and took the small tab as well, putting the first and second fingers of his right hand through, that in drawing the string the flesh might not be cut to the bone. Then he took, from the unwrapped roll of arrows, now spilled on the leather, a flight arrow, and this, to my admiration, he fitted to the bow and drew it to the very pile itself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He held the arrow up, pointing it into the sky, at an angle of some fifty degrees.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then there came the clean, swift, singing flash of the bowstring and the flight arrow was aloft.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There were cries from all, of wonder and astonishment, for they would not have believed such a thing possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The arrow seemed lost, as though among the clouds, and so far was it that it seemed vanished in its falling.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The group was silent.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak unstrung the bow. \"It is with this,\" he said, \"that peasants defend their holdings.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He looked from face to face. Then he replaced the bow, putting it with its arrows, on the leather spread upon the mat of woven rence that was the surface of the island.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak regarded me. \"Are you skilled with this bow?\" he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"See that he does not escape,\" said Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I felt the prongs of two marsh spears in my back. \"He will not escape,\" said the girl, putting her fingers in the ropes that held my throat. I could feel her knuckles in the side of my neck. She shook the ropes. She irritated me. She acted as though it were she herself who had taken me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Are you of the peasants?\" asked Ho-Hak of me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" I said. \"I am of the Warriors.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"This bow, though,\" said one of the men holding my neck ropes, \"is of the Peasants.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am not of the Peasants,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak looked at the man who wore the headband of pearls of the Vosk sorp.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"With such a bow,\" he said to that man, \"we might live free in the marsh, free of those of Port Kar.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is a weapon of peasants,\" said the man with the headband, he who had been unable to bend the bow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"So?\" asked Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I,\" said the man, \"am of the Growers of Rence. I, for one, am not a peasant.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Nor am I!\" cried the girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The others, too, cried their assent.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Besides,\" said another man, \"we do not have metal for the heads of arrows, nor arrowwood, and Ka-la-na does not grow in the marsh. And we do not have cords of strength enough to draw such bows.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"And we do not have leather,\" added another.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We could kill tharlarion,\" said Ho-Hak, \"and obtain leather. And perhaps the teeth of the marsh shark might be fashioned in such a way as to tip arrows.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There is no Ka-la-na, no cord, no arrowwood,\" said another.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We might trade for such things,\" said Ho-Hak. \"There are peasants who live along the edges of the delta, particularly to the east.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man with the headband, he who had not been able to bend the bow, laughed. \"You, Ho-Hak,\" said he, \"were not born to the rence.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" said Ho-Hak. \"That is true.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"But we were,\" said the man. \"We are Growers of the Rence.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was a murmur of assent, grunts and shiftings in the group.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We are not peasants,\" said the man with the headband. \"We are Growers of the Rence!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was an angry cry of confirmation from the group, mutterings, shouts of agreement.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak once again sat down on the curved shell of the great Vosk sorp, that shell that served him as throne in this his domain, an island of rence in the delta of the Vosk.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What is to be done with me?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Torture him for festival,\" suggested the fellow with the headband of the pearls of the Vosk sorp.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak's ears lay flat against the sides of his head. He looked evenly at the fellow. \"We are not of Port Kar,\" said he.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The man with the headband shrugged; looking about he saw that his suggestion had not met with much enthusiasm. This, naturally, did not displease me. He shrugged again, and looked down at the woven surface of the island.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"So,\" I asked, \"what is to be my fate?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We did not ask you here,\" said Ho-Hak. \"We did not invite you to cross the line of the blood mark.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Return to me my belongings,\" I said, \"and I shall be on my way and trouble you no longer.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak smiled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The girl beside me laughed, and so, too, did the man with the headband, he who had not been able to bend the bow. Several of the others laughed as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Of custom,\" said Ho-Hak, \"we give those we capture who are of Port Kar a choice.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What is the choice?\" I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You will be thrown bound to marsh tharlarion, of course,\" said Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I paled.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The choice,\" said Ho-Hak, \"is simple.\" He regarded me. \"Either you will be thrown alive to the marsh tharlarion or, if you wish, we will kill you first.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I struggled wildly against the marsh vine, futilely. The rence growers, without emotion, watched me. I fought the vine for perhaps a full Ehn. Then I stopped. The vine was tight. I knew I had been perfectly secured. I was theirs. The girl beside me laughed, as did the man with the headband, and certain of the others.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"There is never any trace of the body,\" said Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I looked at him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Never,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Again I struggled against the vine, but again futilely.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It seems too easy that he should die so swiftly,\" said the girl. \"He is of Port Kar, or would be of that city.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"True,\" said the fellow with the headband, he who had been unable to bend the bow. \"Let us torture him for festival.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" said the girl. She looked at me with fury. \"Let us rather keep him as a miserable slave.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak looked up at her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Is that not a sweeter vengeance?\" hissed she. \"That rightless he should serve the Growers of Rence as a beast of burden?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Let us rather throw him to tharlarion,\" said the man with the headband of the pearls of the Vosk sorp. \"That way we shall be rid of him.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I say,\" said the blondish girl, \"let us rather shame him and Port Kar as well. Let him be worked and beaten by day and tethered by night. Each hour with labors, and whips and thongs, let us show him our hatred for Port Kar and those of that city!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"How is it,\" I asked the girl, \"that you so hate those of Port Kar?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Silence, Slave!\" she cried and thrust her fingers into the ropes about my neck, twisting her hand. I could not swallow, nor breathe. The faces about me began to blacken. I fought to retain consciousness.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Then she withdrew her hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I gasped for breath, choking. I threw up on the mat. There were cries of disgust, and derision. I felt the prongs of marsh spears in my back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I say,\" said he with the headband, \"let it be the marsh tharlarion.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" I said numbly. \"No.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak looked at me. He seemed surprised.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I, too, found myself stunned. It had seemed the words had scarcely been mine.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No, No,\" I said again, the words again seeming almost those of another.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I began to sweat, and I was afraid.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ho-Hak looked at me, curiously. His large ears leaned toward me, almost inquisitively.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I did not want to die.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I shook my head, clearing my eyes, fighting for breath, and looked into his eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You are of the warriors,\" said Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" I said. \"I know, yes.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I found I desperately wanted the respect of this calm, strong man, he most of all, he once a slave, who sat before me on the throne, that shell of the giant Vosk sorp.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"The teeth of the tharlarion,\" said he, \"are swift, Warrior.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I know,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"If you wish,\" said he, \"we will slay you first.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I,\" I said, \"I do not want to die.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I lowered my head, burning with shame. In my eyes in that moment it seemed I had lost myself, that my codes had been betrayed, Ko-ro-ba my city dishonored, even the blade I had carried soiled. I could not look Ho-Hak again in the eyes. In their eyes, and in mine, I could now be nothing, only slave.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I had thought the better of you,\" said Ho-Hak. \"I had thought you were of the warriors.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I could not speak to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I see now,\" said Ho-Hak, \"you are indeed of Port Kar.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I could not raise my head, so shamed I was. It seemed I could never lift my head again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do you beg to be a slave?\" asked Ho-Hak. The question was cruel, but fair.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I looked at Ho-Hak, tears in my eyes. I saw only contempt on that broad, calm face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I lowered my head. \"Yes,\" I said. \"I beg to be a slave.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was a great laugh from those gathered about, and, too, in those peals of merriment I heard the laugh of he who wore the headband of the pearls of the Vosk sorp, and, most bitter to me of all, the laugh of contempt of the girl who stood beside me, her thigh at my cheek.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Slave,\" said Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said I, \"—Master.\" The word came bitterly to me. But a Gorean slave addresses all free men as Master, all free women as Mistress, though, of course, normally but one would own him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was further laughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps now,\" said Ho-Hak, \"we shall throw you to tharlarion.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I put down my head.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was more laughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("To me, at that moment, it seemed I cared not whether they chose to throw me to tharlarion or not. It seemed to me that I had lost what might be more precious than life itself. How could I face myself, or anyone? I had chosen ignominious bondage to the freedom of honorable death.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I was sick. I was shamed. It was true that they might now throw me to tharlarion. According to Gorean custom a slave is an animal, and may be disposed of as an animal, in whatever way the master might wish, whenever he might please. But I was sick, and I was shamed, and I could not now, somehow, care. I had chosen ignominious bondage to the freedom of honorable death.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Is there anyone who wants this slave?\" I heard Ho-Hak asking.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Give him to me, Ho-Hak,\" I heard. It was the clear, ringing voice of the girl who stood beside me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was a great laughter, and rich in that humiliating thunder was the snort of the fellow who wore the headband, that formed of the pearls of the Vosk sorp.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Strangely I felt small and nothing beside the girl, only chattel. How straight she stood, each inch of her body alive and splendid in her vigor and freedom. And how worthless and miserable was the beast, the slave, that knelt, naked and bound, at her feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"He is yours,\" I heard Ho-Hak say.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I burned with shame.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Bring the paste of rence!\" cried the girl. \"Unbind his ankles. Take these ropes from his neck.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A woman left the group to bring some rence paste, and two men removed the marsh vine from my neck and ankles. My wrists were still bound behind my back.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In a moment the woman had returned with a double handful of wet rence paste. When fried on flat stones it makes a kind of cake, often sprinkled with rence seeds.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Open your mouth, Slave,\" said the girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I did so and, to the amusement of those watching, she forced the wet paste into my mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Eat it,\" she said. \"Swallow it.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Painfully, almost retching, I did so.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You have been fed by your Mistress,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I have been fed by my Mistress,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What is your name, Slave?\" asked she.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Tarl,\" said I.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She struck me savagely, across the mouth, flinging my head to one side.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"A slave has no name,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I have no name,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She walked about me. \"Your back is broad,\" she said. \"You are strong, but stupid.\" She laughed. \"I shall call you Bosk,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The bosk is a large, horned, shambling ruminant of the Gorean plains. It is herded below the Gorean equator by the Wagon Peoples, but there are bosk herds on ranches in the north as well, and peasants often keep some of the animals.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am Bosk,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was laughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"My Bosk!\" she laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I should have thought,\" said he with the headband, formed of the pearls of the Vosk sorp, \"that you might have preferred a man for a slave, one who is proud and does not fear death.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The girl thrust her hands into my hair and threw back my head. Then she spat in my face. \"Coward and slave!\" she hissed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I dropped my head. It was true what she had said. I had feared death. I had chosen slavery. I could not be a true man. I had lost myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You are worthy only to be the slave of a woman,\" said Ho-Hak.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do you know what I am going to do with you?\" asked the girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She laughed. \"In two days,\" she said, \"at festival, I will put you at stake as a prize for girls.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was laughter at this, and shouts of pleasure.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("My shoulders and head fell forward and, bound, I shook with shame.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The girl turned. \"Follow me, Slave,\" said she, imperiously.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I struggled to my feet and, to the jeers of the rence growers, and blows, stumbled after the girl, she who owned me, my mistress.")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c3c2776","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 75
// module chunks = 0